import React from 'react'
import { useTranslation } from 'react-i18next'
import { useShouldShowLanguageSelector } from '@renderer/hooks'

interface LanguageSelectorProps {
  className?: string
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ className = '' }) => {
  const { i18n } = useTranslation()
  // Hide the EN/ID toggle entirely inside non-IDR projects — the kiosk
  // is talking to a non-Indonesian audience there and the toggle is
  // irrelevant noise. Operator chrome outside any project (login,
  // register, dashboard navbar before a project is loaded) still gets
  // the picker because `config?.resolvedCurrency` is undefined.
  const shouldShow = useShouldShowLanguageSelector()
  if (!shouldShow) return null

  const changeLanguage = (lng: string): void => {
    i18n.changeLanguage(lng)
    localStorage.setItem('language', lng)
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <button
        className={`px-2 py-1 rounded text-sm font-medium ${
          i18n.language === 'en' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'
        }`}
        onClick={() => changeLanguage('en')}
      >
        EN
      </button>
      <button
        className={`px-2 py-1 rounded text-sm font-medium ${
          i18n.language === 'id' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'
        }`}
        onClick={() => changeLanguage('id')}
      >
        ID
      </button>
    </div>
  )
}

export default LanguageSelector
